import React, { useMemo } from "react";
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from "components/ui/select";
import { selectTriggerClassName } from "components/Form/Field/selectStyles";
import FilterField from "./FilterField";
import type { FilterOption } from "./MultiSelectFilter";

type SingleSelectFilterProps = {
    clearOption?: FilterOption;
    disabled?: boolean;
    label: string;
    placeholder?: string;
    selectedValue: string;
    options: FilterOption[];
    onChange: (value: string) => void;
};

const SingleSelectFilter: React.FC<SingleSelectFilterProps> = ({
    clearOption,
    disabled = false,
    label,
    placeholder = "",
    selectedValue,
    options,
    onChange,
}) => {
    const displayedOptions = useMemo(() => {
        if (!clearOption) {
            return options;
        }

        return [clearOption, ...options];
    }, [clearOption, options]);

    return (
        <FilterField label={label}>
            <Select value={selectedValue} onValueChange={onChange} disabled={disabled}>
                <SelectTrigger aria-label={label} className={selectTriggerClassName}>
                    <SelectValue placeholder={placeholder} />
                </SelectTrigger>
                <SelectContent>
                    {displayedOptions.map((option) => (
                        <SelectItem key={option.value} value={option.value}>
                            {option.label}
                        </SelectItem>
                    ))}
                </SelectContent>
            </Select>
        </FilterField>
    );
};

export default SingleSelectFilter;
